import {lazy, FC} from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import {useUserInformation} from "./util/useUserInformation";
import {LayoutAuthorized} from "./layouts/LayoutAuthorized/LayoutAuthorized";

const AdminOverviewRoutes = lazy(() =>
    import("./pages/admin-overview/routes").then((exports) => ({
        default: exports.OverviewRoutes,
    }))
);
// const AdminLinkRoutes = lazy(() =>
//     import("./pages/admin-links/routes").then((exports) => ({
//         default: exports.LinkRoutes,
//     }))
// );
const AdminFaqRoutes = lazy(() =>
    import("./pages/admin-faqs/routes").then((exports) => ({
        default: exports.FaqRoutes,
    }))
);
// const AdminProductRoutes = lazy(() =>
//     import("./pages/admin-products/routes").then((exports) => ({
//         default: exports.ProductRoutes,
//     }))
// );
const AdminReportRoutes = lazy(() =>
    import("./pages/admin-reports/routes").then((exports) => ({
        default: exports.ReportRoutes,
    }))
);
const UserManagementRoutes = lazy(() =>
    import("./pages/admin-user/routes").then((exports) => ({
        default: exports.UserManagementRoutes,
    }))
);
const AdminContactListRoutes = lazy(() =>
    import("./pages/admin-contact-list/routes").then((exports) => ({
        default: exports.AdminContactListRoutes,
    }))
);
// const AdminAmparexImportReportsRoutes = lazy(() =>
//     import("./pages/admin-amparex-import-reports/routes").then((exports) => ({
//         default: exports.AmparexImportReportsRoutes,
//     }))
// );
// const AdminOvertimeRoutes = lazy(() =>
//     import("./pages/admin-overtime/routes").then((exports) => ({
//         default: exports.OvertimeRoutes,
//     }))
// );
const AdminTimeRoutes = lazy(() =>
    import("./pages/admin-time/routes").then((exports) => ({
        default: exports.TimeRoutes,
    }))
);
const AdminLoginAsRoutes = lazy(() =>
    import("./pages/admin-login-as/routes").then((exports) => ({
        default: exports.LoginAsRoutes,
    }))
);

const AudiologistOverviewRoutes = lazy(() =>
    import("./pages/audiologist-overview/routes").then((exports) => ({
        default: exports.OverviewRoutes,
    }))
);
const AudiologistReportRoutes = lazy(() =>
    import("./pages/audiologist-reports/routes").then((exports) => ({
        default: exports.ReportRoutes,
    }))
);
const AudiologistStockRoutes = lazy(() =>
    import("./pages/audiologist-stock/routes").then((exports) => ({
        default: exports.StockRoutes,
    }))
);
const AudiologistStockStatementRoutes = lazy(() =>
    import("./pages/audiologist-stock-statement/routes").then((exports) => ({
        default: exports.StockStatementRoutes,
    }))
);
// const AudiologistOvertimeRoutes = lazy(() =>
//     import("./pages/audiologist-overtime/routes").then((exports) => ({
//         default: exports.OvertimeRoutes,
//     }))
// );
const AudiologistGpsRoutes = lazy(() =>
    import("./pages/audiologist-gps/routes").then((exports) => ({
        default: exports.GpsRoutes,
    }))
);

const WarehouseWorkerOverview = lazy(() =>
    import("./pages/warehouse-worker-overview/routes").then((exports) => ({
        default: exports.OverviewRoutes,
    }))
);
// const WarehouseWorkerScan = lazy(() =>
//   import("./pages/warehouse-worker-scan/routes").then((exports) => ({
//     default: exports.ScanRoutes,
//   }))
// );
// const WarehouseWorkerStock = lazy(() =>
//   import("./pages/warehouse-worker-stock/routes").then((exports) => ({
//     default: exports.StockRoutes,
//   }))
// );
const WarehouseWorkerStock2 = lazy(() =>
    import("./pages/warehouse-worker-stock2/routes").then((exports) => ({
        default: exports.Stock2Routes,
    }))
);
const WarehouseWorkerStockMove = lazy(() =>
    import("./pages/warehouse-worker-stock-move/routes").then((exports) => ({
        default: exports.StockMoveRoutes,
    }))
);
const WarehouseWorkerStockDelete = lazy(() =>
    import("./pages/warehouse-worker-stock-delete/routes").then((exports) => ({
        default: exports.StockDeleteRoutes,
    }))
);
const WarehouseWorkerClientList = lazy(() =>
    import("./pages/warehouse-worker-client-list/routes").then((exports) => ({
        default: exports.ClientListRoutes,
    }))
);
const WarehouseWorkerStockTracking = lazy(() =>
    import("./pages/warehouse-worker-stock-tracking/routes").then((exports) => ({
        default: exports.StockTrackingRoutes,
    }))
);
const WarehouseWorkerStockStatements = lazy(() =>
    import("./pages/warehouse-worker-stock-statement/routes").then((exports) => ({
        default: exports.StockStatementRoutes,
    }))
);
// const WarehouseWorkerStockWarnings = lazy(() =>
//   import("./pages/warehouse-worker-stock-warnings/routes").then((exports) => ({
//     default: exports.StockWarningsRoutes,
//   }))
// );
// const WarehouseWorkerReturnNotifications = lazy(() =>
//   import("./pages/warehouse-worker-return-notifications/routes").then((exports) => ({
//     default: exports.ReturnNotificationsRoutes,
//   }))
// );
const WarehouseWorkerImportArticleItems = lazy(() =>
    import("./pages/warehouse-worker-import-article-items/routes").then((exports) => ({
        default: exports.ImportArticleItemsRoutes,
    }))
);

// const MixedProductRoutes = lazy(() =>
//     import("./pages/mixed-products/routes").then((exports) => ({
//         default: exports.ProductRoutes,
//     }))
// );
// const MixedLinkRoutes = lazy(() =>
//     import("./pages/mixed-links/routes").then((exports) => ({
//         default: exports.LinkRoutes,
//     }))
// );
const MixedFaqRoutes = lazy(() =>
    import("./pages/mixed-faq/routes").then((exports) => ({
        default: exports.FaqRoutes,
    }))
);
const MixedAudiologistStockRoutes = lazy(() =>
    import("./pages/mixed-audiologist-stock/routes").then((exports) => ({
        default: exports.AudiologistStockRoutes,
    }))
);
const MixedAudiologistStatsRoutes = lazy(() =>
    import("./pages/mixed-audiologist-stats/routes").then((exports) => ({
        default: exports.AudiologistStatsRoutes,
    }))
);
const MixedCustomerListRoutes = lazy(() =>
    import("./pages/mixed-customer-lists/routes").then((exports) => ({
        default: exports.CustomerListsRoutes,
    }))
);
const MixedOrderRoutes = lazy(() =>
    import("./pages/audiologist-order/routes").then((exports) => ({
        default: exports.OrderRoutes,
    }))
);
const MixedUpdateDataRoutes = lazy(() =>
    import("./pages/mixed-update-data/routes").then((exports) => ({
        default: exports.UpdateDataRoutes,
    }))
);
const MixedBulletinBoardRoutes = lazy(() =>
    import("./pages/mixed-bulletin-board/routes").then((exports) => ({
        default: exports.BulletinBoardRoutes,
    }))
);
const MixedStockNotificationRoutes = lazy(() =>
    import("./pages/mixed-stock-notifications/routes").then((exports) => ({
        default: exports.StockNotificationsRoutes,
    }))
);
const MixedCustomerContactRoutes = lazy(() =>
    import("./pages/mixed-customer-contact/routes").then((exports) => ({
        default: exports.CustomerContactRoutes,
    }))
);

const AdminAudiologistStatsRoutes = lazy(() =>
    import("./pages/admin-audiologist-stats/routes").then((exports) => ({
        default: exports.AdminAudiologistStatsRoutes,
    }))
);

const AllContactListRoutes = lazy(() =>
    import("./pages/all-contact-list/routes").then((exports) => ({
        default: exports.ContactListRoutes,
    }))
);

const AllCalculatorRoutes = lazy(() =>
    import("./pages/all-calculator/routes").then((exports) => ({
        default: exports.CalculatorRoutes,
    }))
);

const AllCustomerDataRoutes = lazy(() =>
    import("./pages/all-customer-data/routes").then((exports) => ({
        default: exports.CustomerDataRoutes,
    }))
);

const AllCoworkerReportRoutes = lazy(() =>
    import("./pages/all-coworker-report/routes").then((exports) => ({
        default: exports.CoworkerReportRoutes,
    }))
);

const AllTimeRoutes = lazy(() =>
    import("./pages/all-time/routes").then((exports) => ({
        default: exports.TimeRoutes,
    }))
);

const AllUserListRoutes = lazy(() =>
    import("./pages/all-user/routes").then((exports) => ({
        default: exports.UserListRoutes,
    }))
);

const AllDocumentsRoutes = lazy(() =>
    import("./pages/all-documents/routes").then((exports) => ({
        default: exports.DocumentsRoutes,
    }))
);

const NoRoleOverviewRoutes = lazy(() =>
    import("./pages/no-role-overview/routes").then((exports) => ({
        default: exports.OverviewRoutes,
    }))
);

const NotFound = lazy(() =>
    import("./pages/Page404").then((exports) => ({default: exports.Page404}))
);

export const RootRouter: FC<{ children?: undefined }> = () => {
    const {
        hasAdminReadAccess,
        hasAudiologReadAccess,
        hasWarehouseWorkerReadAccess,
        hasStatsAdminReadAccess,
        hasCustomerContactReadAccess,
        hasNoRole,
        // userKey: audiologistKey,
        // region: {regionKey}
        staffId,
        country,
    } = useUserInformation();

    return (
        <LayoutAuthorized>
            {/* content */}
            <Switch>
                {/* admin-areas */}
                {hasAdminReadAccess && (
                    <Route path="/admin/overview" component={AdminOverviewRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/admin/reports" component={AdminReportRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/audiologist/order" component={MixedOrderRoutes}/>
                )}
                {/*{hasAdminReadAccess && (*/}
                {/*    <Route path="/admin/products" component={AdminProductRoutes}/>*/}
                {/*)}*/}
                {/*{hasAdminReadAccess && (*/}
                {/*    <Route path="/admin/links" component={AdminLinkRoutes}/>*/}
                {/*)}*/}
                {hasAdminReadAccess && (
                    <Route path="/admin/faqs" component={AdminFaqRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/admin/users" component={UserManagementRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/admin/contact-list" component={AdminContactListRoutes}/>
                )}
                {/*{hasAdminReadAccess && (*/}
                {/*    <Route path="/admin/amparex-import-reports" component={AdminAmparexImportReportsRoutes}/>*/}
                {/*)}*/}
                {/*{hasAdminReadAccess && (*/}
                {/*    <Route path="/admin/overtime" component={AdminOvertimeRoutes}/>*/}
                {/*)}*/}
                {hasAdminReadAccess && (
                    <Route path="/admin/time" component={AdminTimeRoutes}/>
                )}
                {hasAdminReadAccess && staffId === "01785a658c2000007e400021CCD6CDBC" && ( // 01785a658c2000007e400021CCD6CDBC = MOR
                    <Route path="/admin/login-as" component={AdminLoginAsRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/mixed/stock-notifications" component={MixedStockNotificationRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/mixed/data" component={MixedUpdateDataRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route path="/mixed/kundekontakt" component={MixedCustomerContactRoutes}/>
                )}
                {hasAdminReadAccess && (
                    <Route
                        path="/mixed/stats"
                        component={MixedAudiologistStatsRoutes}
                    />
                )}

                {/* audiologist-areas */}
                {hasAudiologReadAccess && (
                    <Route
                        path="/audiologist/overview"
                        component={AudiologistOverviewRoutes}
                    />
                )}
                {hasAudiologReadAccess && (
                    <Route
                        path="/audiologist/reports"
                        component={AudiologistReportRoutes}
                    />
                )}
                {hasAudiologReadAccess && (
                    <Route path="/audiologist/order" component={MixedOrderRoutes}/>
                )}
                {/*{hasAudiologReadAccess && (*/}
                {/*    <Route*/}
                {/*        path="/:role(audiologist)/products"*/}
                {/*        component={MixedProductRoutes}*/}
                {/*    />*/}
                {/*)}*/}
                {/*{hasAudiologReadAccess && (*/}
                {/*    <Route path="/audiologist/links" component={MixedLinkRoutes}/>*/}
                {/*)}*/}
                {hasAudiologReadAccess && (
                    <Route path="/audiologist/faqs" component={MixedFaqRoutes}/>
                )}
                {hasAudiologReadAccess && (
                    <Route path="/audiologist/stock" component={AudiologistStockRoutes}/>
                )}
                {hasAudiologReadAccess && (
                    <Route path="/audiologist/stock-statements" component={AudiologistStockStatementRoutes}/>
                )}
                {/*{hasAudiologReadAccess && (*/}
                {/*  <Route path="/audiologist/overtime" component={AudiologistOvertimeRoutes} />*/}
                {/*)}*/}
                {/*{hasAudiologReadAccess && staffId === "016737b3e7d900007437FC4596EFB594" && (  // 016737b3e7d900007437FC4596EFB594 = Kristine Kjærsgaard ID: 101013 (DK)*/}
                {/*    <Route*/}
                {/*        path="/audiologist/audiologist-stock"*/}
                {/*        component={MixedAudiologistStockRoutes}*/}
                {/*    />*/}
                {/*)}*/}
                {hasAudiologReadAccess && (
                    <Route path="/mixed/data" component={MixedUpdateDataRoutes}/>
                )}
                {hasAudiologReadAccess && (
                    <Route path="/mixed/kundekontakt" component={MixedCustomerContactRoutes}/>
                )}
                {hasAudiologReadAccess && (
                    <Route path="/audiologist/gps" component={AudiologistGpsRoutes}/>
                )}
                {hasAudiologReadAccess && ["016737b3e7d900007437FC4596EFB594", "01808ea773b800008f37806D971A7A40"].includes(staffId) && ( // KK, SAN
                    <Route
                        path="/mixed/stock2"
                        component={WarehouseWorkerStock2}
                    />
                )}
                {hasAudiologReadAccess && (
                    <Route
                        path="/mixed/stats"
                        component={MixedAudiologistStatsRoutes}
                    />
                )}

                {/* warehouse-worker-areas */}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*    <Route*/}
                {/*        path="/:role(warehouse-worker)/products"*/}
                {/*        component={MixedProductRoutes}*/}
                {/*    />*/}
                {/*)}*/}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*    <Route path="/warehouse-worker/links" component={MixedLinkRoutes}/>*/}
                {/*)}*/}
                {hasWarehouseWorkerReadAccess && (
                    <Route path="/warehouse-worker/faqs" component={MixedFaqRoutes}/>
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/overview"
                        component={WarehouseWorkerOverview}
                    />
                )}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*  <Route*/}
                {/*    path="/warehouse-worker/scan"*/}
                {/*    component={WarehouseWorkerScan}*/}
                {/*  />*/}
                {/*)}*/}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*  <Route*/}
                {/*    path="/warehouse-worker/stock"*/}
                {/*    component={WarehouseWorkerStock}*/}
                {/*  />*/}
                {/*)}*/}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock2"
                        component={WarehouseWorkerStock2}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock-move"
                        component={WarehouseWorkerStockMove}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock-delete"
                        component={WarehouseWorkerStockDelete}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/client-list"
                        component={WarehouseWorkerClientList}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/audiologist-stock"
                        component={MixedAudiologistStockRoutes}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock-statements"
                        component={WarehouseWorkerStockStatements}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock-tracking"
                        component={WarehouseWorkerStockTracking}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/stock-statements-shared"
                        component={AudiologistStockStatementRoutes}
                    />
                )}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*  <Route*/}
                {/*    path="/warehouse-worker/stock-warnings"*/}
                {/*    component={WarehouseWorkerStockWarnings}*/}
                {/*  />*/}
                {/*)}*/}
                {/*{hasWarehouseWorkerReadAccess && (*/}
                {/*  <Route*/}
                {/*    path="/warehouse-worker/return-notifications"*/}
                {/*    component={WarehouseWorkerReturnNotifications}*/}
                {/*  />*/}
                {/*)}*/}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/warehouse-worker/import-article-items"
                        component={WarehouseWorkerImportArticleItems}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route
                        path="/mixed/customer-lists"
                        component={MixedCustomerListRoutes}
                    />
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route path="/mixed/data" component={MixedUpdateDataRoutes}/>
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Route path="/mixed/stock-notifications" component={MixedStockNotificationRoutes}/>
                )}
                {hasWarehouseWorkerReadAccess && hasStatsAdminReadAccess && (
                    <Route
                        path="/mixed/stats"
                        component={MixedAudiologistStatsRoutes}
                    />
                )}

                <Route path="/mixed/bulletin-board" component={MixedBulletinBoardRoutes}/>

                {hasStatsAdminReadAccess && (
                    <Route
                        path="/admin/stats"
                        component={AdminAudiologistStatsRoutes}
                    />
                )}

                {/* customer contact-areas */}
                {hasCustomerContactReadAccess && (
                    <Route path="/mixed/kundekontakt" component={MixedCustomerContactRoutes}/>
                )}

                {/* all-areas */}
                {country === "DK" && (
                    <Route path="/all/calculator" component={AllCalculatorRoutes}/>
                )}
                {country === "DK" && (
                    <Route path="/all/customer-data" component={AllCustomerDataRoutes}/>
                )}
                <Route path="/all/contact-list" component={AllContactListRoutes}/>
                <Route path="/all/coworker-status" component={AllCoworkerReportRoutes}/>
                <Route path="/all/time" component={AllTimeRoutes}/>
                <Route path="/all/users" component={AllUserListRoutes}/>
                <Route path="/all/documents" component={AllDocumentsRoutes}/>

                {/* no-role-areas */}
                <Route path="/no-role/overview" component={NoRoleOverviewRoutes}/>

                {/* admin-redirects */}
                {hasAdminReadAccess && (
                    <Redirect exact path="/" to="/admin/overview"/>
                )}
                {hasAdminReadAccess && (
                    <Redirect exact path="/login" to="/admin/overview"/>
                )}
                {hasAdminReadAccess && (
                    <Redirect exact path="/admin" to="/admin/overview"/>
                )}

                {/* audiologist-redirects */}
                {hasAudiologReadAccess && (
                    <Redirect exact path="/" to="/audiologist/overview"/>
                )}
                {hasAudiologReadAccess && (
                    <Redirect exact path="/login" to="/audiologist/overview"/>
                )}
                {hasAudiologReadAccess && (
                    <Redirect exact path="/audiologist" to="/audiologist/overview"/>
                )}

                {/* customer contact redirects */}
                {hasCustomerContactReadAccess && (
                    <Redirect exact path="/" to="/mixed/kundekontakt"/>
                )}
                {hasCustomerContactReadAccess && (
                    <Redirect exact path="/login" to="/mixed/kundekontakt"/>
                )}

                {/* no-role-redirects */}
                {hasNoRole && (
                    <Redirect exact path="/" to="/no-role/overview"/>
                )}
                {hasNoRole && (
                    <Redirect exact path="/login" to="/no-role/overview"/>
                )}
                {hasNoRole && (
                    <Redirect exact path="/no-role" to="/no-role/overview"/>
                )}

                {/* warehouse-worker-redirects */}
                {/*{["016b4d1b2e0b000126e328D24416C1E6", "019b98bc0cf70001330368545AE4EA12", "018e50e0cc2d0000c82d68545AE4EA12"].includes(staffId) // Users SL1, TOP & PAS*/}
                {/*    ?*/}
                {/*    <>*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/" to="/warehouse-worker/stock-move/location-overview"/>*/}
                {/*        )}*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/warehouse-worker" to="/warehouse-worker/stock-move/location-overview"/>*/}
                {/*        )}*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/login" to="/warehouse-worker/stock-move/location-overview"/>*/}
                {/*        )}*/}
                {/*        /!*{hasWarehouseWorkerReadAccess && (*!/*/}
                {/*        /!*    <Redirect exact path="/stock" to="/warehouse-worker/stock"/>*!/*/}
                {/*        /!*)}*!/*/}
                {/*        /!*{hasWarehouseWorkerReadAccess && (*!/*/}
                {/*        /!*    <Redirect exact path="/stock/overview" to="/warehouse-worker/stock/overview"/>*!/*/}
                {/*        /!*)}*!/*/}
                {/*    </>*/}
                {/*    :*/}
                {/*    <>*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/" to="/all/time/overview"/>*/}
                {/*        )}*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/warehouse-worker" to="/all/time/overview"/>*/}
                {/*        )}*/}
                {/*        {hasWarehouseWorkerReadAccess && (*/}
                {/*            <Redirect exact path="/login" to="/all/time/overview"/>*/}
                {/*        )}*/}
                {/*    </>*/}
                {/*}*/}
                {hasWarehouseWorkerReadAccess && (
                    <Redirect exact path="/" to="/warehouse-worker/overview"/>
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Redirect exact path="/login" to="/warehouse-worker/overview"/>
                )}
                {hasWarehouseWorkerReadAccess && (
                    <Redirect exact path="/warehouse-worker" to="/warehouse-worker/overview"/>
                )}

                {/* fallback */}
                <Route component={NotFound}/>
            </Switch>
        </LayoutAuthorized>
    );
};